import { type JSX } from 'react';

import { Box, Text } from '@plurall/elo-v3';
import { createFileRoute } from '@tanstack/react-router';

import { PageContent } from '@/components';
import { PageHeader } from '@/components/PageHeader/PageHeader';
import { useGoHome } from '@/hooks/useHomeRoute';
import { requireAccess } from '@/permissions';

const REDNEWS_PDF_URL = `${import.meta.env.VITE_RED1000_CDN}/novidades/red_news.pdf`;

export const Route = createFileRoute('/rednews')({
  staticData: { title: 'Rednews' },
  beforeLoad: requireAccess('view:manager_dashboard'),
  component: RedNews,
});

function RedNews(): JSX.Element {
  const goHome = useGoHome();

  return (
    <>
      <PageHeader
        title='Rednews'
        showSchoolSelector={false}
        onBack={goHome}
      />
      <PageContent
        display='flex'
        flexDirection='column'
        gap='space.16'>
        <Box
          flex='1'
          height='calc(100vh - 176px)'
          minHeight='600px'
          overflow='hidden'
          borderRadius='medium'
          backgroundColor='background.primary'>
          <object
            aria-label='Documento Rednews'
            data={REDNEWS_PDF_URL}
            type='application/pdf'
            style={{
              border: 0,
              display: 'block',
              height: 'calc(100vh - 176px)',
              width: '100%',
            }}>
            <Text padding='space.16'>
              Seu navegador não conseguiu exibir o PDF.{' '}
              <a
                href={REDNEWS_PDF_URL}
                target='_blank'
                rel='noreferrer'>
                Abrir o documento em outra aba
              </a>
              .
            </Text>
          </object>
        </Box>
      </PageContent>
    </>
  );
}
